import type { State } from "../store/state";
import type { Store } from "vuex";
import type { SearchState, SetDefaultDateFieldPayload } from "../model/searchState";
import { type DefaultDateRangeFieldChoice, getDefaultDateRangeFieldChoices, mediaCreatedDateRangeField } from "../pages/search/util";
import { findDateFilterChoiceForField } from '@mimir/web/util/findDataFilterChoiceForField';
import { mdfState } from '../globals/mdfState';


// TODO: The reason this has to live outside of SearchState is that SearchState
// does not own the filters for some reason. If the filters also resided inside
// the SearchState we could reduce the SearchState API surface substantially.
export function setDefaultDateRangeField(
  store: Store<State>,
  searchState: SearchState,
  payload: SetDefaultDateFieldPayload | undefined
): void {
  if (!payload) {
    store.commit('setDateFilterField', payload);
    return;
  }

  const mdfs = mdfState.state.mdfs;
  let dateFilterFieldChoice: DefaultDateRangeFieldChoice = mediaCreatedDateRangeField;
  if (payload.fieldIdOrGuid) {
    const defaultDateRangeFieldChoices = getDefaultDateRangeFieldChoices(mdfs);
    const match = findDateFilterChoiceForField(defaultDateRangeFieldChoices, payload, mdfs);
    if (match) dateFilterFieldChoice = match;
  }

  searchState.ops.setDefaultDateRangeField({
    fieldIdOrGuid: dateFilterFieldChoice.value,
    formId: dateFilterFieldChoice.customMdf?.id,
  });

  store.commit(
    'setDateFilterField',
    {
      key: dateFilterFieldChoice.value,
      label: dateFilterFieldChoice.label,
      mdf: dateFilterFieldChoice.customMdf
    }
  );
}
